import {
  AnalyticsMetricEnum,
  type AnalyticsMetricUnit,
  FilterCriterionCategoryEnum,
  FilterOperatorEnum,
  SOCIAL_PLATFORM_FILTER_VALUES,
  SocialPlatformAttributeEnum,
  type SocialPlatformFilterValue,
  UserFilterFieldEnum,
  UtmParameterKeyEnum,
} from '../types/filter-criteria.types'
import { SocialItemEnum } from '../types/socials.types'

export const FILTER_CRITERION_CATEGORY_OPTIONS: {
  id: number
  label: string
  value: FilterCriterionCategoryEnum
}[] = [
  { id: 0, label: 'Social platform', value: FilterCriterionCategoryEnum.SocialPlatform },
  { id: 1, label: 'Client', value: FilterCriterionCategoryEnum.Client },
  { id: 2, label: 'Revenue tier', value: FilterCriterionCategoryEnum.RevenueTier },
  { id: 3, label: 'Analytics', value: FilterCriterionCategoryEnum.Analytics },
  { id: 4, label: 'UTM', value: FilterCriterionCategoryEnum.Utm },
  { id: 5, label: 'User', value: FilterCriterionCategoryEnum.User },
]

const SOCIAL_PLATFORM_LABELS: Record<SocialPlatformFilterValue, string> = {
  [SocialItemEnum.Instagram]: 'Instagram',
  [SocialItemEnum.TikTok]: 'TikTok',
  [SocialItemEnum.Snapchat]: 'Snapchat',
  [SocialItemEnum.YouTube]: 'YouTube',
}

export const SOCIAL_PLATFORM_OPTIONS = SOCIAL_PLATFORM_FILTER_VALUES.map((value, id) => ({
  id,
  label: SOCIAL_PLATFORM_LABELS[value],
  value,
}))

/**
 * The platforms whose row offers the attribute dropdown (connected, follower count). Only Instagram
 * reports these; every other platform is an existence check.
 */
export const ATTRIBUTE_FILTER_PLATFORMS: readonly SocialPlatformFilterValue[] = [
  SocialItemEnum.Instagram,
]

export const SOCIAL_PLATFORM_ATTRIBUTE_OPTIONS: {
  id: number
  label: string
  value: SocialPlatformAttributeEnum
}[] = [
  { id: 0, label: 'Existing', value: SocialPlatformAttributeEnum.Existing },
  { id: 1, label: 'Connected', value: SocialPlatformAttributeEnum.Connected },
  { id: 2, label: 'Followers', value: SocialPlatformAttributeEnum.Followers },
]

export const FILTER_OPERATOR_OPTIONS: { id: number; label: string; value: FilterOperatorEnum }[] = [
  { id: 0, label: 'Greater than or equal to', value: FilterOperatorEnum.GreaterThanOrEqual },
  { id: 1, label: 'Less than or equal to', value: FilterOperatorEnum.LessThanOrEqual },
]

export const ANALYTICS_METRIC_OPTIONS: {
  id: number
  label: string
  value: AnalyticsMetricEnum
  unit: AnalyticsMetricUnit
}[] = [
  { id: 0, label: 'Cost', value: AnalyticsMetricEnum.Cost, unit: 'currency' },
  { id: 1, label: 'Revenue', value: AnalyticsMetricEnum.Revenue, unit: 'currency' },
  { id: 2, label: 'Gross profit', value: AnalyticsMetricEnum.GrossProfit, unit: 'currency' },
  { id: 3, label: 'Conversion', value: AnalyticsMetricEnum.Conversion, unit: '%' },
  { id: 4, label: 'Order value', value: AnalyticsMetricEnum.OrderValue, unit: 'currency' },
  { id: 5, label: 'OV per click', value: AnalyticsMetricEnum.OrderValuePerClick, unit: 'currency' },
  {
    id: 6,
    label: 'Est. revenue per click',
    value: AnalyticsMetricEnum.EstRevenuePerClick,
    unit: 'currency',
  },
]

export const UTM_PARAMETER_KEY_OPTIONS: {
  id: number
  label: string
  value: UtmParameterKeyEnum
}[] = [
  { id: 0, label: 'utm_source', value: UtmParameterKeyEnum.Source },
  { id: 1, label: 'utm_medium', value: UtmParameterKeyEnum.Medium },
  { id: 2, label: 'utm_campaign', value: UtmParameterKeyEnum.Campaign },
  { id: 3, label: 'utm_term', value: UtmParameterKeyEnum.Term },
  { id: 4, label: 'utm_content', value: UtmParameterKeyEnum.Content },
]

export const USER_FILTER_FIELD_OPTIONS: {
  id: number
  label: string
  value: UserFilterFieldEnum
}[] = [
  { id: 0, label: 'Registered at', value: UserFilterFieldEnum.RegisteredAt },
  { id: 1, label: 'First active', value: UserFilterFieldEnum.FirstActiveAt },
  { id: 2, label: 'Last active', value: UserFilterFieldEnum.LastActiveAt },
]
